import React from "react";
import Headercomponent from "./Headercomponent"; // Import the Header component

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      {/* Header */}
      <Headercomponent />

      {/* Main Content */}
      <div style={styles.scrollView}>
        <h1 style={styles.heading}>Privacy Policy</h1>
        <p style={styles.paragraph}>
          This privacy policy applies to the Lihen Pharmacy app (hereby referred to as "Application") for mobile devices that was created by Lihen Pharmacy (hereby referred to as "Service Provider"). This service is intended for use "AS IS".
        </p>

        <h2 style={styles.subheading}>Information Collection and Use</h2>
        <p style={styles.paragraph}>
          The Application collects information when you download and use it. This information may include information such as your device's Internet Protocol address (e.g. IP address), the pages of the Application that you visit, the time and date of your visit, the time spent on those pages, the time spent on the Application, and the operating system you use on your mobile device.
        </p>
        <p style={styles.paragraph}>
          The Application does not gather precise information about the location of your mobile device.
        </p>
        <p style={styles.paragraph}>
          The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices, and marketing promotions.
        </p>
        <p style={styles.paragraph}>
          For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information. The information that the Service Provider request will be retained by them and used as described in this privacy policy.
        </p>

        <h2 style={styles.subheading}>Third Party Access</h2>
        <p style={styles.paragraph}>
          Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.
        </p>
        <p style={styles.paragraph}>
          Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:
        </p>
        <p style={styles.paragraph}>
          - Google Play Services
        </p>
        <p style={styles.paragraph}>
          The Service Provider may disclose User Provided and Automatically Collected Information:
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            as required by law, such as to comply with a subpoena, or similar legal process;
          </li>
          <li style={styles.listItem}>
            when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;
          </li>
          <li style={styles.listItem}>
            with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.
          </li>
        </ul>

        <h2 style={styles.subheading}>Opt-Out Rights</h2>
        <p style={styles.paragraph}>
          You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
        </p>

        <h2 style={styles.subheading}>Data Retention Policy</h2>
        <p style={styles.paragraph}>
          The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at Lihenpharmacy@gmail.com and they will respond in a reasonable time.
        </p>

        <h2 style={styles.subheading}>Children</h2>
        <p style={styles.paragraph}>
          The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 18.
        </p>
        <p style={styles.paragraph}>
          The Application does not address anyone under the age of 18. The Service Provider does not knowingly collect personally identifiable information from children under 18 years of age. In the case the Service Provider discovers that a child under 18 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (Lihenpharmacy@gmail.com) so that they will be able to take the necessary actions.
        </p>

        <h2 style={styles.subheading}>Security</h2>
        <p style={styles.paragraph}>
          The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.
        </p>

        <h2 style={styles.subheading}>Changes</h2>
        <p style={styles.paragraph}>
          This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
        </p>
        <p style={styles.paragraph}>
          This privacy policy is effective as of 2024-05-23.
        </p>

        <h2 style={styles.subheading}>Your Consent</h2>
        <p style={styles.paragraph}>
          By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
        </p>

        <h2 style={styles.subheading}>Contact Us</h2>
        <p style={styles.paragraph}>
          If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at Lihenpharmacy@gmail.com.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "#f8f8f8",
    minHeight: "100vh",
  },
  scrollView: {
    padding: "20px",
    maxWidth: "800px",
    margin: "0 auto",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#2e7d32",
    marginBottom: "20px",
  },
  subheading: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#2e7d32",
    marginBottom: "10px",
    marginTop: "20px",
  },
  paragraph: {
    fontSize: "16px",
    color: "#333",
    lineHeight: "24px",
    textAlign: "justify",
    marginBottom: "10px",
  },
  list: {
    marginLeft: "20px",
    marginBottom: "10px",
  },
  listItem: {
    fontSize: "16px",
    color: "#333",
    lineHeight: "24px",
    textAlign: "justify",
    marginBottom: "5px",
  },
};

export default PrivacyPolicy;